/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Group_MonthInputs */

const vi_report_group_month = /** @type {(inputs: Report_Group_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng`)
};

/**

* @param {Report_Group_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_group_month = /** @type {((inputs?: Report_Group_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Group_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_group_month(inputs)
});